/* eslint-disable max-len */
import { useContext, useEffect, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import styled from "styled-components";
import Card from "../../components/Card";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import MuiIcon from "@mui/material/Icon";
import { RightAlign } from "../../components/UtilsComponents";
import { StyledText, TextSize, TextStatus } from "../../components/Text";
import CompetencyNavbar from "../../components/CompetencyNavbar";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import axios from "axios";
import { PillarType } from "../../types/Roadmap";
import LoadingSpinner from "../../components/LoadingSpinner";
import { getDomainWidth } from "../../hooks/generateMobileUi";
import { CustomBlock, StyledImg } from "../../components/CompetenciesList";
import Icon from "@mui/material/Icon";
import defaultImg from "../../assets/DefaultCardImage.png";
import CompetencyAddModal from "../../components/CompetencyAddModal";
import { CompetencyType } from "../../types/Milestone";
import { SemesterContext } from "../../context/SemesterContext";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import SnackBar from "../../components/SnackBar";
import CompetencyAddModalNew from "../../components/CompetencyAddModalNew";
import { handleJWTError } from "../../hooks/jwtErrHandler";
import {
  hasNoCurriculumVersionsForExplore,
} from "../../utils/exploreCompetency";
import { UniversityContext } from "../../context/UniversityContext";
import ExploreNoVersionState from "../../components/ExploreNoVersionState";
import { PrerequisiteChainModal } from "../../components/prerequisiteChainModal";
import { ReactFlowProvider } from "@xyflow/react";
const DomainCard = styled(FlexBox)`
  padding: 16px;
  width: auto;
  height: 264px;
  background: #191b34;
  border-radius: 8px;
  cursor: pointer;
  flex-wrap: nowrap;
`;
export const CustomDomainBlock = styled(FlexGrow) <{ blockWidth: string }>`
  flex-grow: 0;
  margin-bottom: 20px;
  max-width: ${({ blockWidth }) => blockWidth};
  min-width: ${({ blockWidth }) => blockWidth};
  min-height: 300px;
  max-height: 300px;
`;
const StyledHr = styled.hr`
  width: 100%;
  border-color: #3c406c;
`;
function Domains() {
  const navigate = useNavigate();
  const test = [{ name: "Quests", link: "/explore" }];
  const redirectDetail = (id: string, node: string) => {
    navigate("/explore/child", { state: { id, node } });
  };
  const screenClass = useScreenClass();
  const [pillars, setPillars] = useState<PillarType | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const isTablet = useMemo(() => ["md"].includes(screenClass), [screenClass]);
  const [competencies, setCompetencies] = useState<Array<any> | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { user, selectedVersion, setSearchView } = useContext(UserContext);
  const [selectedCompetency, setSelectedCompetency] = useState<any>({});
  const semesterContext = useContext(SemesterContext);
  const [stuSelectedVersion, setStuSelectedVersion] = useState<Number>(0);
  const [activeVersion, setActiveVersion] = useState<Number>(0);
  const [message, setMessage] = useState<string>("");
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [warningMessage, setWarningMessage] = useState<any>(null);
  const [warningOpen, setWarningOpen] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [chainModalOpen, setChainModalOpen] = useState<boolean>(false);
  const [onHover, setHover] = useState<string | null>(null);

  const currentUser = useContext(UserContext).user;
  const universityContext = useContext(UniversityContext);
  const storedRole = localStorage.getItem("role");
  const initialRole = JSON.parse(storedRole as string);
  useEffect(() => {
    fetchCompetencies();
    initialRole.role !== 1 && getVersion();
    initialRole.role === 1 && fetchStudentCompetencies();
  }, [semesterContext]);

  useEffect(() => {
    searchValue && searchCompetencies(searchValue);
  }, [semesterContext.selectedSemester, semesterContext.selectedSemesterVersion]);

  const getVersion = () => {
    axios
      .get(`/version?university_code=CMKL`)
      .then((res) => {
        const active_version = res.data.versions.find(
          (v: any) => v.status === "Active Prime"
        ).version_number;
        setActiveVersion(active_version);
      })
      .catch(() => { });
  };
  const clearSearch = () => {
    fetchCompetencies();
    setShowFilter(false);
  };

  //get student competencies for roadmap
  const fetchStudentCompetencies = async () => {
    try {
      const res = await axios.get(
        `/roadmap/milestones?student_id=${initialRole.role_id}&year=${semesterContext.selectedSemester.year}&semester=${semesterContext.selectedSemester.label}&program_name=${currentUser?.programs?.[0]?.program_name || universityContext.selectedProgram?.short_name}`
      );
      if (
        res.data &&
        res.data.roadmaps &&
        res.data.roadmaps[0] &&
        res.data.roadmaps[0].milestones
      ) {
        const tempArr: any = [];
        res.data.roadmaps[0].milestones.forEach((v: any) => {
          tempArr.push(v.competency_card?.competency_code);
        });

        return tempArr;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching student competencies:", error);
      return [];
    }
  };

  const fetchCompetencies = () => {
    const storedRole = localStorage.getItem("role");
    const initialRole = JSON.parse(storedRole as string);

    if (
      hasNoCurriculumVersionsForExplore(
        user.role,
        semesterContext.selectedSemester,
        semesterContext.semesterVersions,
        semesterContext.semesterVersionsLoading
      )
    ) {
      setLoading(false);
      setPillars(null);
      setShowFilter(false);
      return;
    }

    if (user.role !== 1 && semesterContext.semesterVersionsLoading) {
      setLoading(true);
      return;
    }

    setLoading(true);

    if (user.role !== 1) {
      axios
        .get(`/version?university_code=CMKL`)
        .then((res) => {
          const active_version = res.data.versions.find(
            (v: any) => v.status === "Active Prime"
          ).version_number;
          setActiveVersion(active_version);

          axios
            .get(
              `/subdomain?curriculum_version=${semesterContext.selectedSemesterVersion !== 0 ? semesterContext.selectedSemesterVersion : active_version
              // selectedVersion === 0 ||
              // semesterContext.selectedSemester.label !== "All"
              //   ? active_version
              //   : selectedVersion
              }`
            )
            .then((res1) => {
              filterData(res1.data.pillars);
            })
            .catch((err) => {
              setLoading(false);
              setPillars([]);
            });
        })
        .catch((err) => {
          setLoading(false);
          handleJWTError(err);
        });
    } else {
      semesterContext.selectedSemester.label === "All"
        ? axios
          .get(`/version?university_code=CMKL`)
          .then((res) => {
            const active_version = res.data.versions.find(
              (v: any) => v.status === "Active Prime"
            ).version_number;
            setActiveVersion(active_version);

            axios
              .get(
                `/subdomain?curriculum_version=${semesterContext.selectedSemesterVersion === 0 ||
                  semesterContext.selectedSemester.label !== "All"
                  ? active_version
                  : semesterContext.selectedSemesterVersion
                }`
              )
              .then((res1) => {
                filterData(res1.data.pillars);
              })
              .catch((err) => {
                setLoading(false);
                setPillars([]);
                handleJWTError(err);
              });
          })
          .catch((err) => {
            setLoading(false);
            handleJWTError(err);
          })
        :
        semesterContext?.selectedSemester?.label && axios
          .get(
            `/student/version?student_id=${initialRole.role_id}&semester_name=${semesterContext?.selectedSemester?.label}&program_id=${user.programs[0].id}`
          )
          .then((res) => {
            setStuSelectedVersion(res.data.version.curriculum_version);
            axios
              .get(
                `/subdomain?curriculum_version=${res.data.version.curriculum_version}`
              )
              .then((res) => {
                filterData(res.data.pillars);
              })
              .catch((err) => {
                handleJWTError(err);
              });
          })
          .catch((err) => {
            setLoading(false);
            setPillars([]);
            handleJWTError(err);
          });
    }
  };
  const filterCompetencies = async (competenciesArr: Array<{}>) => {
    try {
      let filteredData: Array<{}> = [];
      const studentCompetencies = await fetchStudentCompetencies();

      competenciesArr.forEach((comp: any) => {
        if (
          comp.semester_detail &&
          comp.semester_detail.semester_name !== "" &&
          comp.available
        ) {
          filteredData.push(comp);
        }
      });

      //include true to all the competencies that match
      const result1 = competenciesArr.map((item: any) => {
        const shouldInclude = studentCompetencies.includes(
          item.competency_code
        );

        return {
          ...item,
          ...(shouldInclude && { included: true }),
        };
      });
      setCompetencies(result1);
    } catch (error) {
      console.error("Error filtering competencies:", error);
    }
  };
  const filterData = (data: any) => {
    const custom: PillarType = [];
    data.forEach((element: any, index: any) => {
      custom.push({
        id: element.id,
        node: index + 1,
        label: element.title,
        description: element.description,
        iconBg: element.graphics.iconbg,
        borderColor: element.graphics.bordercolor,
        icon: element.graphics.icon,
        iconShadow: element.graphics.iconshadow,
        children: [],
      });
      if (element.subdomains && element.subdomains.length > 0) {
        element.subdomains.forEach((elementChild: any, indexChild: any) => {
          custom[index].children.push({
            id: elementChild.id,
            node: Number(
              String(data.length) + String(index + 1) + String(indexChild + 1)
            ),
            label: elementChild.title,
            count: "0/7",
            icon: "",
            description: elementChild.description,
          });
        });
      }
    });
    setPillars(custom);
    setLoading(false);
  };
  const searchCompetencies = (searchVal: string) => {
    setCompetencies(null);
    setSearchView(true);
    setLoading(true);
    setSearchValue(searchVal);
    if (!searchVal || searchVal === "") {
      setShowFilter(false);
    } else {
      let axiosStr = "/competency/summary?university_code=CMKL";
      if (
        user.role !== 1 ||
        semesterContext?.selectedSemester?.label === "All"
      ) {
        axiosStr =
          semesterContext.selectedSemester?.label === "All"
            ? `/competency/summary?university_code=CMKL&curriculum_version=${semesterContext.selectedSemesterVersion === 0 ? activeVersion : semesterContext.selectedSemesterVersion
            }`
            : `/competency/summary?university_code=CMKL&curriculum_version=${semesterContext.selectedSemesterVersion === 0 ? activeVersion : semesterContext.selectedSemesterVersion
            }&semester_name=${semesterContext.selectedSemester.label}`;

        axios
          .get(axiosStr)
          .then((res) => {
            if (res.data.competencies) {
              if (res.data.competencies && res.data.competencies.length > 0) {
                setLoading(true);

                let searchArray = searchVal.trim().split(" ");
                let re = new RegExp(searchArray.join("|"), "i");
                // let resultsObj = res.data.competencies.filter(
                //   (competencyItem: CompetencyType) =>
                //     re.test(competencyItem.competency_code) ||
                //     re.test(competencyItem.title)
                // );
                let resultsObj =
                  searchVal.trimStart() !== ""
                    ? res.data.competencies.filter(
                      (competencyItem: CompetencyType) =>
                        competencyItem.competency_code
                          .toLowerCase()
                          .includes(searchVal.trimStart().toLowerCase()) ||
                        competencyItem.title
                          .toLowerCase()
                          .includes(searchVal.trimStart().toLowerCase())
                    )
                    : [];
                setCompetencies(resultsObj);
                setLoading(false);
              } else {
                setCompetencies([]);
                setLoading(false);
              }
            } else {
              setCompetencies([]);
              setLoading(false);
            }
          })
          .catch(() => {
            setCompetencies([]);
            setLoading(false);
          });
      }
      // else if (
      //   semesterContext.selectedSemester?.label &&
      //   semesterContext.selectedSemester.label === "All"
      // ) {
      //   axiosStr = "/competency/summary?university_code=CMKL";
      // }
      else {
        const storedRole = localStorage.getItem("role");
        const initialRole = JSON.parse(storedRole as string);
        axios
          .get(
            `/student/version?student_id=${initialRole.role_id}&semester_name=${semesterContext.selectedSemester.label}&program_id=${user.programs[0].id}`
          )
          .then((versionRes) => {
            axiosStr =
              semesterContext.selectedSemester?.label &&
              `/competency/summary?university_code=CMKL&curriculum_version=${versionRes.data.version.curriculum_version}&semester_name=${semesterContext.selectedSemester.label}`;
            axios
              .get(axiosStr)
              .then((res) => {
                if (res.data.competencies) {
                  if (
                    res.data.competencies &&
                    res.data.competencies.length > 0
                  ) {
                    // let searchArray = searchVal.trimStart();
                    // let re = new RegExp(searchArray.join("|"), "i");
                    // let resultsObj = res.data.competencies.filter(
                    //   (competencyItem: CompetencyType) =>
                    //     re.test(competencyItem.competency_code) ||
                    //     re.test(competencyItem.title)
                    // );

                    let resultsObj =
                      searchVal.trimStart() !== ""
                        ? res.data.competencies.filter(
                          (competencyItem: CompetencyType) =>
                            competencyItem.competency_code
                              .toLowerCase()
                              .includes(
                                searchVal.trimStart().toLowerCase()
                              ) ||
                            competencyItem.title
                              .toLowerCase()
                              .includes(searchVal.trimStart().toLowerCase())
                        )
                        : [];
                    filterCompetencies(resultsObj);
                  } else {
                    setCompetencies([]);
                  }
                } else {
                  setCompetencies([]);
                }
                setLoading(false);
              })
              .catch(() => {
                setCompetencies([]);
                setLoading(false);
              });
          });
      }
      // axios
      //   .get(axiosStr)
      //   .then((res) => {
      //     console.log('res',res.data.competencies)
      //     if (res.data.competencies) {
      //       console.log('have')
      //       if (res.data.competencies && res.data.competencies.length > 0) {
      //         let searchArray = searchVal.trim().split(" ");
      //         let re = new RegExp(searchArray.join("|"), "i");
      //         let resultsObj = res.data.competencies.filter(
      //           (competencyItem: CompetencyType) =>
      //             re.test(competencyItem.competency_code) ||
      //             re.test(competencyItem.title)
      //         );
      //         setCompetencies(resultsObj);
      //       } else {
      //         console.log('not have')
      //         setCompetencies([]);
      //       }
      //     }
      //     else{
      //       setCompetencies([]);
      //     }
      //     setLoading(false);
      //   })
      //   .catch(() => {
      //     setCompetencies([]);
      //     setLoading(false);
      //   });
      setShowFilter(true);
    }
  };

  if (
    user.role !== 1 &&
    semesterContext.semesterVersionsLoading &&
    semesterContext.selectedSemester?.label &&
    semesterContext.selectedSemester.label !== "All"
  ) {
    return <LoadingSpinner />;
  }

  if (
    hasNoCurriculumVersionsForExplore(
      user.role,
      semesterContext.selectedSemester,
      semesterContext.semesterVersions,
      semesterContext.semesterVersionsLoading
    )
  ) {
    return (
      <ExploreNoVersionState
        programLabel={
          universityContext.selectedProgram?.label ||
          universityContext.selectedProgram?.short_name
        }
        semesterLabel={semesterContext.selectedSemester?.label}
      />
    );
  }

  if (pillars?.length === 0) {
    return (
      <FlexGrow style={{ textAlign: "center", paddingTop: "30px" }}>
        <StyledText color="red" fontWeight="700" textSize={TextSize.default}>
          No pillars found for the selected semester
        </StyledText>
      </FlexGrow>
    );
  }
  return (
    <>
      {isSnackbarOpen && (
        <SnackBar
          isOpen={isSnackbarOpen}
          setOpen={setIsSnackbarOpen}
          message={message}
          type="success"
          link
        />
      )}
      {isErrorOpen && (
        <SnackBar
          isOpen={isErrorOpen}
          setOpen={setIsErrorOpen}
          header="INFO!"
          message="This competency has been added already"
          type="info"
        />
      )}
      {isModalOpen && (
        <CompetencyAddModalNew
          isWarningOpen={warningOpen}
          setIsWarningOpen={setWarningOpen}
          warningMessage={warningMessage}
          fetchCompetency={() =>
            searchValue ? searchCompetencies(searchValue) : fetchCompetencies()
          }
          setMessage={setMessage}
          isSnackbarOpen={isSnackbarOpen}
          setIsSnackbarOpen={setIsSnackbarOpen}
          setWarningMessage={setWarningMessage}
          setWarningOpen={setWarningOpen}
          isStudent={user.role === 1}
          isAddModalOpen={isModalOpen}
          setAddModalOpen={setIsModalOpen}
          data={selectedCompetency}
          onAddComplete={() => { }}
          onAddError={() => { }}
        />
      )}
      {selectedCompetency?.id && (
        <ReactFlowProvider>
          <PrerequisiteChainModal
            setSelectedCompetency={setSelectedCompetency}
            isPrerequisiteModalOpen={chainModalOpen}
            setIsPrerequisiteModalOpen={setChainModalOpen}
            focusCompetency={selectedCompetency?.competency_code}
            focusId={selectedCompetency?.id}
            selectedVersion={
              semesterContext.selectedSemesterVersion || activeVersion
            }
            role={initialRole}
          />
        </ReactFlowProvider>
      )}
      <CompetencyNavbar
        breadcrumb={[]}
        searchCompetency={searchCompetencies}
        clearSearch={() => clearSearch()}
      />
      {loading ? (
        <LoadingSpinner />
      ) : !showFilter ? (
        <FlexBox alignItems="flex-start" style={{ marginRight: "-8px" }}>
          <>
            {pillars?.map((item: any) => (
              <CustomDomainBlock
                blockWidth={getDomainWidth(isMobile, isTablet)}
              >
                <DomainCard
                  direction="column"
                  alignItems="flex-start"
                  onClick={() => {
                    redirectDetail(item.id, item.node);
                  }}
                >
                  <FlexGrow style={{ flexGrow: "0" }}>
                    <MuiIcon
                      sx={{
                        color: "white",
                        padding: "6px",
                        background: item.iconBg,
                        boxShadow: item.iconShadow,
                        borderRadius: "100px",
                        fontSize: "48px",
                      }}
                    >
                      {item.icon}
                    </MuiIcon>
                  </FlexGrow>
                  <FlexGrow style={{ flexGrow: "0" }}>
                    <StyledText
                      textSize={TextSize.paragraph}
                      fontWeight="600"
                      style={{ textTransform: "uppercase" }}
                    >
                      {item.label}
                    </StyledText>
                  </FlexGrow>
                  <FlexGrow style={{ overflow: "hidden" }}>
                    <StyledText
                      status={TextStatus.muted}
                      textSize={TextSize.default}
                      fontWeight="normal"
                    >
                      {item.description}
                    </StyledText>
                  </FlexGrow>
                  <FlexGrow
                    style={{ minWidth: "100%", flexGrow: "0", margin: "0" }}
                  >
                    <StyledHr />
                  </FlexGrow>
                  <FlexGrow
                    style={{ minWidth: "100%", flexGrow: "0", margin: "0" }}
                  >
                    <RightAlign>
                      <StyledText
                        status={TextStatus.muted}
                        textSize={TextSize.small}
                        fontWeight="normal"
                      >
                        {item?.children ? item.children.length : 0} domains
                      </StyledText>
                    </RightAlign>
                  </FlexGrow>
                </DomainCard>
              </CustomDomainBlock>
            ))}
          </>
        </FlexBox>
      ) : (
        <FlexBox
          space={1}
          alignItems="flex-start"
          style={{
            marginRight: "-16px",
            minHeight: "60vh",
          }}
        >
          {competencies && competencies?.length > 0 ? (
            competencies?.map((competency: any) => (
              <>
                <FlexBox
                  direction="column"
                  space={0}
                  style={{
                    marginBottom: "13px",
                    opacity: competency.included ? "0.5" : "1",
                  }}
                >
                  <CustomBlock
                    // style={{ opacity: competency.included ? "0.5" : "1" }}
                    backgroundColor={
                      competency.graphics ? competency.graphics.iconbg : "red"
                    }
                    onClick={() => {
                      if (!competency.included) {
                        setSelectedCompetency(competency);
                        setIsModalOpen(true);
                      } else {
                        setIsErrorOpen(true);
                        setIsErrorOpen(true);
                      }
                    }}
                  >
                    <div style={{ padding: "5px 0px", fontWeight: "bold" }}>
                      {competency.competency_code}
                    </div>
                    <StyledImg
                      src={
                        competency.graphics && competency.graphics.imgurl
                          ? process.env.REACT_APP_IMG_URL +
                          competency.graphics.imgurl
                          : defaultImg
                      }
                      alt=""
                    />
                    <Icon
                      sx={{
                        color: "white",
                        padding: "6px",
                        background: competency.graphics
                          ? competency.graphics.iconbg
                          : "red",
                        borderRadius: "100px",
                        fontSize: "27px",
                        position: "absolute",
                        left: "50%",
                        bottom: "105px",
                        transform: "translateX(-50%)",
                        boxShadow: competency.graphics
                          ? competency.graphics.iconshadow
                          : "black",
                      }}
                    >
                      {competency.graphics ? competency.graphics.icon : "help"}
                    </Icon>
                    <StyledText fontWeight="700">
                      {competency.title}
                      {competency?.prerequisites?.length > 0 && (
                        <Icon
                          onMouseEnter={() => {
                            setHover(competency.id);
                          }}
                          onMouseLeave={() => {
                            setHover(null);
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedCompetency(competency);
                            setChainModalOpen(true);
                          }}
                          title="Prerequistes exist"
                          sx={{
                            width: onHover === competency.id ? "50px" : "none",
                            color: "#007f00",
                            background: "white",
                            padding: "4px",
                            borderBottomLeftRadius: "10px",
                            borderTopLeftRadius: "10px",
                            position: "absolute",
                            zIndex: 100,
                            top: competency?.required ? 45 : 7,
                            right: 0,
                            boxShadow: "0 4px 4px #0000007a",
                            border:
                              onHover === competency.id
                                ? "1px solid rgb(0, 163, 0)"
                                : "1px solid transparent",
                          }}
                        >
                          add_task
                        </Icon>
                      )}
                      {competency?.required && (
                        <Icon
                          title="Required for graduation"
                          sx={{
                            color: "#ff6600",
                            background: "white",
                            padding: "4px",
                            borderBottomLeftRadius: "10px",
                            borderTopLeftRadius: "10px",
                            // fontSize: "22px",
                            position: "absolute",
                            zIndex: 100,
                            top: 7,
                            right: 0,
                            boxShadow: "0 4px 4px #0000007a",
                          }}
                        >
                          star
                        </Icon>
                      )}
                    </StyledText>
                  </CustomBlock>
                  {competency.semester_detail &&
                    competency.semester_detail.assessment_only === true && (
                      <FlexGrow style={{ width: "100%" }}>
                        <div
                          style={{
                            textAlign: "center",
                            background:
                              "linear-gradient(270deg,#3a84ee 0%,#1a5edf 100%)",
                            paddingTop: "8px",
                            borderBottomRightRadius: "12px",
                            borderBottomLeftRadius: "12px",
                            marginTop: -8,
                          }}
                        >
                          <StyledText
                            style={{
                              lineHeight: "35px",
                              fontWeight: "bold",
                              textTransform: "uppercase",
                              fontSize: "0.8rem",
                            }}
                          >
                            Assessment Only
                          </StyledText>
                        </div>
                      </FlexGrow>
                    )}
                </FlexBox>
              </>
            ))
          ) : (
            <FlexGrow style={{ textAlign: "center" }}>
              <StyledText
                color="red"
                fontWeight="700"
                textSize={TextSize.default}
              >
                {competencies && <span>No matching competency found.</span>}
              </StyledText>
            </FlexGrow>
          )}
        </FlexBox>
      )}
    </>
  );
}
export default Domains;
